export default {
    "heatmap": {
        "name": "Carte de chaleur",
        "nodata": "Pas de données à afficher",
        "loading": "Chargement",
        "maxX": "Nombre maximum d'éléments sur l'axe X",
        "maxY": "Nombre maximum d'éléments sur l'axe Y",
        "rescale": "Redimensionner les axes",
        "colors": "Jeu de couleurs",
        "blue": "Bleu",
        "red": "Rouge",
        "green": "Vert",
        "diverging": "Divergent",
        "spectral": "Spectre",
        "cool": "Froid",
        "defaults": "Valeurs par défaut",
        "showing": "{shown, number} sur {total, number} éléments affichés",
        "tooltip": "{count, plural, one {# élément} other {# éléments}}"
    }
};
